/**
 * Dispatched on window each time the gallery dialog opens. A component that listens for the gallery's pick
 * (`gallery-design-clicked`) reads it to know whether this open was its own.
 */
export const GALLERY_DIALOG_OPENED_EVENT = 'galleryDialogOpened';

export interface GalleryDialogOpenedDetail {
  /** Who opened the gallery; null for a caller that does not identify itself. */
  openerId: string | null;
}
